var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { SettingsPanelComponent } from '../settings-panel.component';
var BillingSettingsComponent = /** @class */ (function (_super) {
    __extends(BillingSettingsComponent, _super);
    function BillingSettingsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.acceptedCards = [];
        return _this;
    }
    BillingSettingsComponent.prototype.ngOnInit = function () {
        this.acceptedCards = this.settings.getJson('billing.accepted_cards', []);
    };
    /**
     * Save current settings to the server.
     */
    BillingSettingsComponent.prototype.saveSettings = function () {
        var settings = this.state.getModified();
        settings.client['billing.accepted_cards'] = JSON.stringify(this.acceptedCards);
        _super.prototype.saveSettings.call(this, settings);
    };
    return BillingSettingsComponent;
}(SettingsPanelComponent));
export { BillingSettingsComponent };
